import { HomePage } from "./../home/home";
import { PlazaThemeChangeSavePage } from "./../plaza-theme-change-save/plaza-theme-change-save";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { PlazaSlotThemePage } from "../plaza-slot-theme/plaza-slot-theme";

@IonicPage()
@Component({
  selector: "page-plaza-theme-change",
  templateUrl: "plaza-theme-change.html",
})
export class PlazaThemeChangePage {
  themes: any;
  MyThemes: any;
  check = 0;
  theme1 = "";
  theme2 = "";
  theme_no = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.theme_no = this.navParams.data.theme.theme_no;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLTheme;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.themes = data;

            var link2 = this.services.URLGetTheme;

            this.http
              .get(link2, requestOptions)
              .map((res) => res.json())
              .subscribe(
                (data) => {
                  this.MyThemes = data;
                  this.check = data.length;

                  let i = 1;
                  this.MyThemes.forEach((element) => {
                    if (i == 1) {
                      this.theme1 = element.theme.theme_id;
                    } else {
                      this.theme2 = element.theme.theme_id;
                    }
                    i++;
                  });

                  loader.dismiss();
                },
                (error) => {
                  var response = JSON.parse(error._body);
                  loader.dismiss();
                  this.translateService
                    .get(response.message)
                    .subscribe((value) => {
                      this.services.presentToast(value);
                    });
                }
              );
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  selectTheme(val) {
    this.navCtrl.push(PlazaThemeChangeSavePage, {
      theme: val,
      theme_no: this.theme_no,
    });
  }

  backPage() {
    this.navCtrl.setRoot(PlazaSlotThemePage);
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-theme-change/plaza-theme-change.ts